import LoginAvatarScreen from './LoginAvatarScreen'
import OAuth from '../components/OAuth'
import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../styles/images/logo/trx-logo.png'
import uniLogo from '../styles/images/logo/rutgers-logo.png'

/**
 * Gets user props from App.js
 * Deals with the login avatar and oauth
 * if user is authorized, allow them to use the home button
 * @param props
 * @returns {*}
 * @constructor
 */
const HeaderScreen = (props) => {
  console.log('HeaderScreen', props)
  return (
    <nav className="header">
      <div className='homeButton'>
        <Link to={{pathname: '/Home'}}>
          <img src={uniLogo} alt="Villanova"/>
          <span className='powerText'>Powered By</span>
          <img src={logo} alt="TraderX"/>
        </Link>
      </div>
      <div className="timeHeader">
        {!!props.time &&
          <h1>{props.time.substring(11,19)}</h1>
        }
      </div>
      <div className="logAv">
        <LoginAvatarScreen user={props.user}/>
      </div>
      <div className="oAuth">
        <OAuth user={props.user}/>
      </div>
    </nav>
  )
}

export default HeaderScreen



// WEBPACK FOOTER //
// ./src/screens/HeaderScreen.js